module.exports = __webpack_public_path__ + "img/Islands_Background.6417abec.png";